<template>
<d-skeleton v-if="isLoading">slot_string</d-skeleton>
<span v-else-if="ashtml" v-html="text"></span>
 <span v-else>{{ text }}</span>
</template>

<script setup>
import { computed, useSlots, defineProps } from 'vue'
const slots = useSlots();
// globals
import { useTranslationsStore } from '@/dod/store/dtranslations';
const translationsStore = useTranslationsStore(); // Use the globally registered store

const defaultSlotContent = computed(() => slots.default ? slots.default() : null);
// props
const props = defineProps({  
    ashtml: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    item: {type: Object}
})

// computed
const slot_string = computed(() => defaultSlotContent?.value?.[0]?.children ?? "")
const translated = computed(() => isLoading.value ? "": translationsStore.translate(slot_string.value, replaceValues.value))
const isLoading = computed(() => !translationsStore.loaded || props.loading)
const translate = computed(() => props.item?.translate === false ? false: true)
const text = computed(() => translate.value? translated.value : slot_string.value)
const replaceValues = computed(() => props.item?.replaceValues ?? {})
</script>
